import { isHTML } from '@/utils/thmlUtls'

import { TTextHTMLProps } from './types'

export const TextHTML = ({ title, ...props }: TTextHTMLProps) => {
  const resolvedTitle = typeof title === 'function' ? title() : title
  const htmlRegex = isHTML(resolvedTitle)

  if (htmlRegex) {
    return <div {...props} dangerouslySetInnerHTML={{ __html: resolvedTitle }} />
  }
  return <div {...props}>{resolvedTitle}</div>
}
